import React, { useEffect, useRef, useLayoutEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import LandLordTopBar from "../components/Header/TopBar";
import LandLordSideBar from "../components/Header/SideBar";

const pageTitles = {
  "/landlords": "Overview",
  "/landlords/user-profile" : "User Profile",
  "/landlords/portfolio-performance" : "Portfolio Performance Report",
  "/landlords/occupancy-rate" : "Occupancy Insights",
  "/landlords/payment-distribution" : "Payment Distribution Report",
  "/landlords/payment-history" : "Payment History",
  "/landlords/manage-property" : "Manage Properties",
  "/landlords/manage-property/view-details": "Property Details: Units & Tenants",
  "/landlords/manage-property/payments/:unitId": "View Payments",
  "/landlords/manage-property/add-tenant": "Tenant Details",
  "/landlords/manage-property/tenant-details-form/:unitId": "Tenant Details",
  "/landlords/notifications": "Notification Center",
  "/landlords/legal-support": "Legal Support",
  "/landlords/request-maintenance": "Request Maintenance",
  "/landlords/tax-consulation": "Tax Consultation Request",
};

const LandlodLayout = () => {
  const location = useLocation();
  const { user } = useSelector((state) => state.auth);

  // Logic to match dynamic routes and handle `add-tenant` and `edit-tenant` specifically
  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  let title = "Overview Page Content";

  if (location.pathname.includes("manage-property") && location.pathname.includes("add-tenant")) {
    title = "Tenant Details";
  } else if (location.pathname.includes("manage-property") && location.pathname.includes("edit-tenant")) {
    title = "Tenant Details";
  } else {
  const temp = Object.keys(pageTitles)?.filter((it) => {
    if (
      it?.split("/")?.slice(1, 4)?.join("/") ===
      location.pathname?.split("/")?.slice(1, 4)?.join("/")
    ) {
      return it;
    }
  });
   title = pageTitles[temp[0]] || "Overview Page Content";
 }

  // Create user object with firstname and lastname
  const userProfile = {
    name: user ? `${user.firstName || ''} ${user.lastName || ''}`.trim() : 'Guest User',
    profilePicture: user?.profilePicture || null,
    email: user?.email || null,
    ...user
  };

  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTo({ top: 0, left: 0, behavior: "instant" }); // or "auto" / "smooth"
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div className="min-h-screen min-w-[320px] w-full bg-white">
      <aside className="fixed top-0 left-0 z-40 h-full">
        <LandLordSideBar />
      </aside>
      <div className='bg-red-400 lg:ml-[300px] h-screen flex flex-col'>
        <div className='bg-yellow-300 h-[79px]'>
         <LandLordTopBar title={title} user={userProfile}/>
        </div>
        <div ref={contentRef} className='w-full flex-1 bg-[#F5F7FA] overflow-y-auto'>
          <Outlet key={location.pathname}/>
        </div>
      </div>
    </div>
  )
}

export default LandlodLayout
